import { render, staticRenderFns } from "./adressDialog.vue?vue&type=template&id=0912abc6&scoped=true"
import script from "./adressDialog.vue?vue&type=script&lang=js"
export * from "./adressDialog.vue?vue&type=script&lang=js"
import style0 from "./adressDialog.vue?vue&type=style&index=0&id=0912abc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0912abc6",
  null
  
)

export default component.exports